import React, { useState } from 'react'
import logo from '../assets/logowbg.png';
import stalin from '../assets/stalin.jpg';
import tnwclogo from '../assets/tnwclogo.avif';
import { Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { BsTranslate } from "react-icons/bs";
import Translate from '../pages/Translate';

const NAV_TABS = [
    { label: "Home", path: "/" },
    { label: "About", path: "/about" },
    { label: "Statistics", path: "/statistics" },
    { label: "Services", path: "/services" },
    { label: "Tenders", path: "/tenders" },
    // { label: "Documents", path: "/documents" },
    { label: "RTI", path: "/rti" },
    { label: "Gallery", path: "/gallery" },
    // { label: "Other Links", path: "/other-links" },
    { label: "Contact Us", path: "/contact-us" }
];

const newsItems = [
    "Tamil Nadu Warehousing Corporation updates new warehouse guidelines.",
    "Occupancy reports for November 2025 are now available.",
    "New RTI documents uploaded for public access.",
    "Safety protocols updated for all regional offices.",
];

function Navbar() {
    const location = useLocation();
    const navigate = useNavigate();
    const [showLoginModal, setShowLoginModal] = useState(false);

    const items = NAV_TABS.map((tab) => ({
        key: tab.path,
        label: tab.label,
        onClick: () => navigate(tab.path),
    }));


    const [error, setError] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [Signin, setSignin] = useState({
        username: "",
        password: ""
    })
    const [lang, setLang] = useState("en");

    const changeLanguage = () => {
        const combo = document.querySelector(".goog-te-combo");

        if (!combo) {
            console.log("Translator not ready yet");
            return;
        }

        const newLang = lang === "en" ? "ta" : "en";

        combo.value = newLang;
        combo.dispatchEvent(new Event("change"));

        setLang(newLang);
    };

    const handlelogin = async (e) => {
        e.preventDefault();

        if (!Signin?.username || !Signin?.password) {
            alert("All fields are mandatory");
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("user_id", Signin.username);
            formData.append("password", Signin.password);

            const response = await fetch("https://ambronex.in/apis/login.php", {
                method: "POST",
                body: formData
            });

            if (!response.ok) {
                throw new error("Network response was not ok");
            }

            const data = await response.json();

            if (data?.status === "success") {
                setSignin({
                    username: "",
                    password: ""
                });
                setShowLoginModal(false);
                setError(false);

                const UserData = {
                    id: data?.data[0]?.id,
                    role: data?.data[0]?.role,
                    name: data?.data[0]?.name,
                    user_id: data?.data[0]?.user_id,
                };
                const login = {
                    isLoggedIn: true,
                    token: data?.data[0]?.token,
                    valid: data?.data[0]?.expires_at
                };

                if (data?.data[0]?.role === "Manager") {
                    navigate("/warehouse-dashboard");
                    sessionStorage.setItem("userdetails", JSON.stringify(UserData || {}));
                    sessionStorage.setItem("loginCredential", JSON.stringify(login || {}));
                } else if (data?.data[0]?.role === "Admin") {
                    navigate("/warehouse-Admin");
                    sessionStorage.setItem("userdetails", JSON.stringify(UserData || {}));
                    sessionStorage.setItem("loginCredential", JSON.stringify(login || {}));
                } else {
                    navigate("/");
                    alert("Unauthorized User");
                }

            } else {
                console.log(data?.message || "Invalid username or password.");
                setError(data?.message)
            }

        } catch (error) {
            console.error("Login Error:", error);
            setError(error)
            console.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = () => {
        sessionStorage.removeItem("userdetails");
        sessionStorage.removeItem("loginCredential");
        navigate("/");
    }

    const storedData = JSON.parse(sessionStorage.getItem("loginCredential"));
    const isLoggedIn = storedData?.isLoggedIn === true;

    return (
        <>
            {/* Top Navbar: Images */}
            <nav className="navbar-expand-lg shadow-sm py-2">
                <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center text-center text-lg-start">

                    {/* Left Section */}
                    <div className="d-flex flex-column flex-md-row align-items-center gap-2">
                        <img
                            src={tnwclogo}
                            alt="Tamil Nadu Warehousing Logo"
                            style={{ height: "80px", width: "auto" }}
                        />

                        <div className="brand-text">
                            <div className="fw-bold fs-6 lh-1" style={{ color: "#0A2158" }}>
                                தமிழ்நாடு சேமிப்புக் கிடங்கு நிறுவனம்
                            </div>

                            <div className="fw-normal small text-danger mb-1">
                                (தமிழக அரசு சார்பு நிறுவனம்)
                            </div>

                            <div className="fw-bold fs-6 lh-1" style={{ color: "#0A2158" }}>
                                TAMIL NADU WAREHOUSING CORPORATION
                            </div>

                            <div className="fw-normal small text-danger">
                                (A Government of Tamil Nadu Sponsored Undertaking)
                            </div>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="d-flex flex-column flex-md-row align-items-center gap-3 mt-3 mt-lg-0">

                        <img
                            src={logo}
                            alt="Tamil Nadu Logo"
                            style={{ height: "80px", width: "auto" }}
                        />

                        <div className="text-center text-md-end">
                            <h6 className="mb-1 fw-bold text-primary">MK STALIN</h6>
                            <p
                                className="mb-0 text-muted small fst-italic"
                                style={{ whiteSpace: "nowrap", fontSize: ".8rem" }}
                            >
                                Hon’ble Chief Minister Govt. of Tamil Nadu
                            </p>
                        </div>

                        <img
                            src={stalin}
                            alt="MK Stalin"
                            className="rounded-circle"
                            style={{
                                height: "80px",
                                width: "80px",
                                objectFit: "cover",
                                border: "3px solid #0d6efd"
                            }}
                        />

                    </div>

                </div>
            </nav>

            <nav className="navbar navbar-expand-lg py-0">
                <div className='container-fluid' style={{ backgroundColor: "#0056b3", color: "white", height: "40px" }}>

                    <div className="container d-flex align-items-center">
                        {/* Left fixed label */}
                        <div
                            className="d-flex align-items-center px-3 py-0 my-0 fw-bold text-dark"
                            style={{ backgroundColor: "#d3dce6", whiteSpace: "nowrap" }}
                        >
                            News & Announcements
                        </div>

                        {/* Scrolling news */}
                        <div
                            className="flex-grow-1 overflow-hidden"
                            style={{ whiteSpace: "nowrap", position: "relative" }}
                        >
                            <div
                                className="d-inline-block"
                                style={{
                                    animation: "scroll-left 20s linear infinite",
                                    paddingLeft: "100%",
                                }}
                            >
                                {newsItems.map((item, idx) => (
                                    <span
                                        key={idx}
                                        className={`px-4 fw-semibold ${item === "NEW" ? "text-warning" : "text-white"
                                            }`}
                                        style={{ whiteSpace: "nowrap" }}
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div
                            onClick={changeLanguage}
                            className="d-flex align-items-center justify-content-center bg-light border rounded-3 shadow-sm text-secondary p-2"
                            style={{ width: "40px", height: "30px", cursor: "pointer" }}
                        >
                            <BsTranslate />
                        </div>

                        <Translate />


                        {/* Inline keyframes animation */}
                        <style>{`
                        @keyframes scroll-left {
                            0% { transform: translateX(0); }
                            100% { transform: translateX(-100%); }
                        }
                    `}</style>
                    </div>
                </div>
            </nav>

            <nav className="navbar navbar-expand-lg  w-100"
                style={{ zIndex: 10, backgroundColor: "#0A2158" }}>
                <div className="container-fluid d-flex align-items-center px-4" style={{ backgroundColor: "#0A2158", height: 50, maxWidth: "1200px" }}>

                    {/* Left: Logo + Divider */}
                    <div className="d-flex align-items-center flex-shrink-0">
                        <a className="navbar-brand text-white fw-bold fs-2 mb-0">TNWC</a>
                        <div
                            className="vr d-none d-lg-block ms-3"
                            style={{ background: "rgba(255,255,255,0.4)", width: 2, height: 50 }}
                        />
                    </div>

                    {/* Center: Menu */}
                    {!isLoggedIn &&
                        <div className="flex-grow-1" style={{
                            minWidth: 0, display: "flex",
                            maxWidth: "900px", justifyContent: "center"
                        }}>
                            <Menu
                                mode="horizontal"
                                items={items}
                                theme="dark"
                                selectedKeys={[location.pathname]}
                                overflowedIndicator={<EllipsisOutlined style={{ color: "white", fontSize: 18 }} />}
                                style={{
                                    backgroundColor: "transparent",
                                    borderBottom: "none",
                                    width: "100%",
                                    minWidth: 0,
                                    display: "flex",
                                    justifyContent: "center",
                                    maxWidth: "900px"

                                }}
                            />
                        </div>
                    }


                    {/* Right: Divider + Login Button */}
                    <div className="d-flex align-items-center flex-shrink-0">
                        <div
                            className="vr d-none d-lg-block me-3"
                            style={{ background: "rgba(255,255,255,0.4)", width: 2, height: 50 }}
                        />
                        {isLoggedIn ? (
                            <button
                                className="btn btn-outline-light px-4 fw-semibold"
                                onClick={handleLogout}
                                type="button"
                            >
                                Logout
                            </button>
                        ) : (
                            <button
                                className="btn btn-outline-light px-4 fw-semibold"
                                type="button"
                                onClick={() => setShowLoginModal(true)}
                            >
                                Login
                            </button>
                        )}
                    </div>
                </div>
            </nav>


            {showLoginModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        backdropFilter: "blur(5px)"
                    }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content border-0 shadow-lg"
                            style={{
                                borderRadius: "16px",
                                overflow: "hidden"
                            }}
                        >

                            {/* Header */}
                            <div className="modal-header border-0 pb-0 position-relative justify-content-center">

                                <div className="text-center">
                                    <h4 className="fw-bold mb-1">Welcome Back</h4>
                                    <small className="text-muted">
                                        Please login to continue
                                    </small>
                                </div>

                                <button
                                    type="button"
                                    className="btn-close position-absolute end-0 me-3"
                                    onClick={() => setShowLoginModal(false)}
                                />

                            </div>

                            {/* Body */}
                            <div className="modal-body pt-3 px-4">

                                <form onSubmit={handlelogin}>

                                    {/* Username */}
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold text-primary">
                                            <i className="bi bi-person-fill"></i> Username
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter username"
                                            value={Signin?.username}
                                            onChange={(e) =>
                                                setSignin((pv) => ({
                                                    ...pv,
                                                    username: e.target.value
                                                }))
                                            }
                                            disabled={Loading}
                                            required
                                            style={{
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>

                                    {/* Password */}
                                    <div className="mb-4">
                                        <label className="form-label fw-semibold text-primary">
                                            <i className="bi bi-eye-slash-fill"></i> Password
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            placeholder="Enter password"
                                            value={Signin?.password}
                                            onChange={(e) =>
                                                setSignin((pv) => ({
                                                    ...pv,
                                                    password: e.target.value
                                                }))
                                            }
                                            disabled={Loading}
                                            required
                                            style={{
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>

                                    {error && (
                                        <div className="alert alert-danger py-2">
                                            {error}
                                        </div>
                                    )}

                                    {/* Login Button */}
                                    <div className="d-flex justify-content-end">

                                        <button
                                            disabled={Loading}
                                            type="submit"
                                            className="btn fw-semibold text-end"
                                            style={{
                                                background: "linear-gradient(135deg,#0A2158,#1d4ed8)",
                                                color: "white",
                                                padding: "12px",
                                                borderRadius: "10px",
                                                fontSize: "16px"
                                            }}
                                        >
                                            {Loading ? "Signing in..." : "Login"}
                                        </button>

                                    </div>
                                </form>

                            </div>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Navbar